export default __webpack_public_path__ + "static/media/p2.4cb56f08.png";